/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  LOGIN: 'FA_login',
  LOGOUT: 'FA_logout',
  PAGE_VIEW: 'FA_pageview',
  OFFER_ACCEPT_FROM_CARD: 'FA_offer_accept_from_card',
  OFFER_REJECT_FROM_CARD: 'FA_offer_reject_from_card',
  OFFER_ACCEPT_FROM_DETAIL: 'FA_offer_accept_from_detail',
  OFFER_REJECT_FROM_DETAIL: 'FA_offer_reject_from_detail',
  OFFER_DETAIL_VIEWED: 'FA__offers__offer_detail_viewed',
  OFFER_BID_FROM_DETAIL: 'FA_offer_bid_from_detail',
  DRIVER_ASSIGN: 'FA_driver_assign',
  VEHICLE_ASSIGN: 'FA_vehicle_assign',
  ASK_PUSH: 'FA_notifications_asked',
  ALLOW_PUSH: 'FA_notifications_accept_clicked',
  BLOCK_PUSH: 'FA_notifications_block_clicked',
  REQUEST_PASSWORD: 'FA_user_request_reset_password',
  RESET_PASSWORD: 'FA_user_reset_password',
  CHANGE_PASSWORD: 'FA_user_change_password',
  CHAT_PAGEVIEW: 'FA_chat_page_view',
  CHAT_CONVERSATION_OPEN: 'FA_chat_conversation_open',
  CHAT_CONVERSATION_CREATE: 'FA_chat_conversation_create',
  CHAT_CONVERSATION_SEND: 'FA_chat_message_sent',
  JOURNEY_ORDER_DOWNLOAD_REQUESTED: 'FA_order_download_requested',
  UPLOADED_POD: 'FA_journey_uploaded_pod',
  OPENED_POD_MODAL: 'FA_pod_modal_opened',
  JOURNEY_STATUS_ADVANCED: 'FA_journey_status_advanced',
  BANNER_CLOSED: 'FA_banner_closed',
  BANNER_NEW_USER_PWD_CREATE: 'FA_banner_new_pwd_create',
  BANNER_ACCEPT_COM_COM: 'FA_banner_accept_com_com',
  DMS_UPLOAD_DOCUMENT: 'FA_dms_upload',
  DMS_CANCEL_DOCUMENT: 'FA_dms_cancel',
  DMS_FILTER_CLICKED: 'FA_dms_filter_clicked',
  NAVBAR_HELP_LINK_CLICKED: 'FA_navbar_help-link_click',
  FAST_VEHICLE_FORM_OPEN: 'FA_fast_vehicle_form_opened',
  FAST_VEHICLE_CREATED_AND_ASSIGNED: 'FA-fast_vehicle_created_and_assigned',
};
